import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const navigate = useNavigate();

  const handleLogin = () => {
    if (username === 'admin' && password === 'pass123') {
      localStorage.setItem('auth', 'true');
      navigate('/dashboard_sell_nuc');
    } else {
      alert('Invalid credentials');
    }
  };

  return (
    <div style={styles.container}>
      <h2 style={styles.header}>Login</h2>
      <input
        style={styles.input}
        placeholder="Username"
        onChange={(e) => setUsername(e.target.value)}
      /><br /><br />
      <input
        style={styles.input}
        type="password"
        placeholder="Password"
        onChange={(e) => setPassword(e.target.value)}
      /><br /><br />
      <button style={styles.button} onClick={handleLogin}>Login</button>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: '50px',
    height: '100vh',
    backgroundColor: '#f0f0f0',
    borderRadius: '10px',
  },
  header: {
    fontSize: '32px',
    fontWeight: '600',
    color: '#333',
    marginBottom: '30px',
  },
  input: {
    padding: '10px',
    margin: '10px 0',
    width: '300px',
    border: '1px solid #ccc',
    borderRadius: '5px',
    fontSize: '16px',
  },
  button: {
    padding: '12px 25px',
    backgroundColor: 'rgb(0, 229, 255)',
    border: 'none',
    borderRadius: '5px',
    color: 'white',
    fontSize: '18px',
    cursor: 'pointer',
    transition: 'background-color 0.3s',
  },
};

